const DEFAULT_FAVICON = '/vnpf-icon.png';

// index.html's <link rel="icon"> is static, so a custom app icon (Settings >
// Branding) can only take effect by rewriting that tag's href at runtime,
// same "override once settings load" approach as applyThemeColors().
export function applyFavicon(iconUrl: string | null): void {
  const link = (document.querySelector<HTMLLinkElement>("link[rel='icon']") ?? document.createElement('link'));
  link.rel = 'icon';
  link.href = iconUrl ?? DEFAULT_FAVICON;
  if (!link.parentElement) document.head.appendChild(link);
}
